import { getFormation } from '../utils/formations'

const POSITION_NUMBERS = {
  football: {
    1: 'Goalkeeper', 2: 'Right Corner Back', 3: 'Full Back', 4: 'Left Corner Back',
    5: 'Right Half Back', 6: 'Centre Back', 7: 'Left Half Back',
    8: 'Midfield', 9: 'Midfield', 10: 'Right Half Forward', 11: 'Centre Forward',
    12: 'Left Half Forward', 13: 'Right Corner Forward', 14: 'Full Forward', 15: 'Left Corner Forward'
  },
  hurling: {
    1: 'Goalkeeper', 2: 'Right Corner Back', 3: 'Full Back', 4: 'Left Corner Back',
    5: 'Right Half Back', 6: 'Centre Back', 7: 'Left Half Back',
    8: 'Midfield', 9: 'Midfield', 10: 'Right Half Forward', 11: 'Centre Forward',
    12: 'Left Half Forward', 13: 'Right Corner Forward', 14: 'Full Forward', 15: 'Left Corner Forward'
  }
}

const POSITIONS = [
  { num: 1,  x: 50, y: 92 }, { num: 2,  x: 85, y: 80 }, { num: 3,  x: 50, y: 80 },
  { num: 4,  x: 15, y: 80 }, { num: 5,  x: 85, y: 65 }, { num: 6,  x: 50, y: 65 },
  { num: 7,  x: 15, y: 65 }, { num: 8,  x: 30, y: 50 }, { num: 9,  x: 70, y: 50 },
  { num: 10, x: 85, y: 35 }, { num: 11, x: 50, y: 35 }, { num: 12, x: 15, y: 35 },
  { num: 13, x: 85, y: 18 }, { num: 14, x: 50, y: 10 }, { num: 15, x: 15, y: 18 },
]

export default function PitchDisplay({ lineup, sport, onPlayerTap, swapFirst, redCardedPlayers = [], blackCardPlayers = [], emptySlots = false, onEmptySlotTap = null, multiSubsOff = [], playersPerSide = null }) {
  if (!sport) return null
  const formation = playersPerSide ? getFormation(playersPerSide) : null
  const activePositions = formation ? formation.positions : POSITIONS
  const positionNames = formation ? formation.positionNames : (POSITION_NUMBERS[sport] || POSITION_NUMBERS.football)
  return (
    <div style={{ position: 'relative', width: '100%', paddingBottom: '170%', background: '#2d7a3a', borderRadius: '8px', overflow: 'hidden' }}>
      <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }} viewBox="0 0 100 170">
        <rect width="100" height="170" fill="#2d7a3a" />
        {[0,1,2,3,4,5,6,7,8,9].map(i => <rect key={i} x="0" y={i*17} width="100" height="17" fill={i%2===0?'#2d7a3a':'#317d3e'} />)}
        <rect x="3" y="3" width="94" height="164" fill="none" stroke="white" strokeWidth="0.8" />
        <line x1="3" y1="85" x2="97" y2="85" stroke="white" strokeWidth="0.8" />
        <rect x="13" y="3" width="74" height="24" fill="none" stroke="white" strokeWidth="0.7" />
        <rect x="28" y="3" width="44" height="12" fill="none" stroke="white" strokeWidth="0.7" />
        <rect x="13" y="143" width="74" height="24" fill="none" stroke="white" strokeWidth="0.7" />
        <rect x="28" y="155" width="44" height="12" fill="none" stroke="white" strokeWidth="0.7" />
      </svg>
      {activePositions.map(pos => {
        const player = lineup.find(p => String(p.assigned_number) === String(pos.num))
        const isRed = player && redCardedPlayers.includes(player.id)
        const isBlack = player && blackCardPlayers.some(x => x.id === player.id)
        const isSwapSelected = swapFirst && swapFirst !== 'pending' && player && swapFirst.id === player.id
        const isMultiSubOff = player && multiSubsOff.some(p => p.id === player.id)
        if (!player) {
          return (
            <button key={pos.num} onClick={() => onEmptySlotTap && onEmptySlotTap(pos.num)}
              style={{ position: 'absolute', left: pos.x + '%', top: pos.y + '%', transform: 'translate(-50%,-50%)', background: 'none', border: 'none', cursor: emptySlots ? 'pointer' : 'default', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px', zIndex: 2, width: '64px' }}>
              <div style={{ width: '34px', height: '34px', borderRadius: '50%', background: 'rgba(255,255,255,0.1)', border: '2px dashed rgba(255,255,255,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', color: 'rgba(255,255,255,0.7)' }}>{pos.num}</div>
              <span style={{ fontSize: '7px', color: 'rgba(255,255,255,0.8)', textAlign: 'center', width: '64px', lineHeight: '1.2', fontWeight: '500', textShadow: '0 1px 2px rgba(0,0,0,0.8)' }}>{positionNames[pos.num]}</span>
            </button>
          )
        }
        const bgColor = isMultiSubOff ? '#A32D2D' : isSwapSelected ? '#FFD700' : isRed ? '#A32D2D' : isBlack ? '#444' : '#185FA5'
        const [firstName, ...rest] = player.full_name.split(' ')
        const lastName = rest.join(' ')
        const displayNum = player.match_number || player.jersey_number || player.assigned_number || '—'
        return (
          <button key={pos.num} onClick={() => onPlayerTap(player)}
            style={{ position: 'absolute', left: pos.x + '%', top: pos.y + '%', transform: 'translate(-50%,-50%)', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px', zIndex: 2, width: '60px', opacity: isRed ? 0.6 : 1 }}>
            <div style={{ width: '34px', height: '34px', borderRadius: '50%', background: bgColor, border: '2px solid ' + (isSwapSelected ? '#FF8C00' : 'white'), display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', fontWeight: '700', color: 'white', boxShadow: '0 2px 4px rgba(0,0,0,0.4)' }}>
              {isRed ? '🟥' : isBlack ? '⬛' : displayNum}
            </div>
            <span style={{ fontSize: '8px', color: 'white', fontWeight: '500', textShadow: '0 1px 3px rgba(0,0,0,0.9)', textAlign: 'center', width: '60px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{firstName}</span>
            <span style={{ fontSize: '8px', color: 'white', fontWeight: '700', textShadow: '0 1px 3px rgba(0,0,0,0.9)', textAlign: 'center', width: '60px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{lastName}</span>
          </button>
        )
      })}
    </div>
  )
}